import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Toolbar } from "./components";
import { connect } from "react-redux";
import * as actions_stock from "redux/actions/watchStockActions";
import * as actions_list from "redux/actions/watchListActions";


const List = (props) => {

  const { className, history, ...rest } = props;
  const [list, setList] = useState(props.list);

  useEffect(() => {
    loadCombo();
    props.loadListStock({ 
      id: props.user_id,
      // list_id:list[0]
     }, props.token);
  }, list);

  const loadCombo = async()=>{
      await props.loadListWatchList(props.user_id, props.token);
  }

  return (
    <div className="watchlist-page" >/
      <div className="watchlist-header">
        <div>
          <h1 className="watchlist-title">Watchlist</h1>
          <p className="watchlist-subtitle">
            Keep track of your favorite symbols and follow their intraday moves.
          </p>
        </div>
      </div>
      <div className="watchlist-card">
        <Toolbar />
        <div className="watchlist-content">
          <Table />
        </div>
      </div>
    </div>
  );
};

List.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object
};

function mapStateToProps(reducer) {
  //console.log(reducer);
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,

    list: reducer.watchStock.list,
    error: reducer.watchStock.error,
    loading: reducer.watchStock.loading,
  };
}
const mapDispatchToProps = dispatch => ({
  loadListStock: (params, token) =>
    dispatch(actions_stock.loadList({ params, token })),
  loadListWatchList: (user_id, token) =>
    dispatch(actions_list.loadList({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(List);